export default "__VITE_ASSET__CVqRloka__"